module.exports = __webpack_public_path__ + "startpage-746fed5a/template-2-2x-142cb8d8ec97b7e647bf983dba81499f.jpg";